var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import * as R from 'ramda';
import cx from 'classnames';
import PropTypes from 'prop-types';
import TextField from '@mui/material/TextField';
import makeStyles from '@mui/styles/makeStyles';
import Typography from '@mui/material/Typography';
import Help from '@mui/icons-material/Help';
import Tooltip from '../Tooltip/Tooltip';
import { withBlank } from '../utils';

var useStyles = makeStyles(function (theme) {
  return {
    root: {
      display: 'flex',
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(0.5),
      alignItems: 'center'
    },
    textField: {
      margin: '0px 10px 0 10px'
    },
    input: {
      padding: '4px 4px',
      height: 27,
      '&[type=number]::-webkit-inner-spin-button, &[type=number]::-webkit-outer-spin-button': {
        '-webkit-appearance': 'none',
        margin: 0
      },
      '&[type=number]': {
        '-moz-appearance': 'textfield'
      }
    },
    icon: {
      marginLeft: theme.spacing(0.5)
    }
  };
});

var InputNumber = function InputNumber(_ref) {
  var value = _ref.value,
      _onChange = _ref.onChange,
      beforeLabel = _ref.beforeLabel,
      afterLabel = _ref.afterLabel,
      popperLabel = _ref.popperLabel,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === undefined ? '--' : _ref$placeholder,
      textFieldProps = _ref.textFieldProps,
      ariaLabel = _ref.ariaLabel;

  var classes = useStyles();

  var _value = R.anyPass([R.isEmpty, R.isNil, function (nb) {
    return R.lte(Number(nb), 0);
  }])(value) ? '' : value;

  return React.createElement(
    'div',
    { 'data-testid': 'input-number-test-id', className: classes.root },
    beforeLabel && React.createElement(
      Typography,
      { variant: 'body2', 'aria-label': beforeLabel, tabIndex: -1 },
      beforeLabel
    ),
    React.createElement(TextField, _extends({
      className: classes.textField,
      inputProps: {
        min: 0,
        step: 1,
        className: classes.input,
        'aria-label': ariaLabel
      },
      placeholder: placeholder,
      onChange: function onChange(e) {
        return _onChange(e.target.value);
      },
      type: 'number',
      value: _value,
      variant: 'outlined'
    }, textFieldProps)),
    R.not(R.isNil(afterLabel)) && React.createElement(
      Typography,
      { variant: 'body2', 'aria-label': afterLabel, tabIndex: 0 },
      afterLabel
    ),
    R.not(R.isNil(popperLabel)) && React.createElement(
      Tooltip,
      {
        className: cx(classes.icon),
        title: popperLabel,
        'aria-label': popperLabel,
        variant: 'light',
        tabIndex: 0
      },
      React.createElement(Help, null)
    )
  );
};

InputNumber.propTypes = process.env.NODE_ENV !== "production" ? {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  beforeLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  afterLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  popperLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  textFieldProps: PropTypes.object,
  ariaLabel: PropTypes.string
} : {};

export default withBlank(function (_ref2) {
  var isBlank = _ref2.isBlank;
  return { isBlank: isBlank };
})(InputNumber);